module.exports = __webpack_public_path__ + "static/img/kxxlogo.3e398a55.png";